import "./Certificates.module.css";
import MainIndustrialHeader from "@/reusable_sections/Header";
import QualityAssuranceStandards from "./sections/QualityAssuranceStandards";
import CertifiedDocumentGallery from "./sections/CertifiedDocumentGallery";
import IndustrialFooter from "@/reusable_sections/Footer";
export default function CertificatesPage() {
  return <div>
      <MainIndustrialHeader />
      <QualityAssuranceStandards />
      <CertifiedDocumentGallery />
      <IndustrialFooter />
    </div>;
}